/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreditsDetail,
    CreditsDetailFromJSON,
    CreditsDetailFromJSONTyped,
    CreditsDetailToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreditsDetailResponse
 */
export interface CreditsDetailResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof CreditsDetailResponse
     */
    msg: string;
    /**
     * 
     * @type {CreditsDetail}
     * @memberof CreditsDetailResponse
     */
    entry: CreditsDetail;
}

export function CreditsDetailResponseFromJSON(json: any): CreditsDetailResponse {
    return CreditsDetailResponseFromJSONTyped(json, false);
}

export function CreditsDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditsDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': CreditsDetailFromJSON(json['entry']),
    };
}

export function CreditsDetailResponseToJSON(value?: CreditsDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': CreditsDetailToJSON(value.entry),
    };
}


